import { Box, Button, Typography } from "@mui/material";
import type { FC } from "react";
import type { ResultDisplay } from "../context/moment-polls-context";

export const PollsAnswers: FC<{
  results: ResultDisplay[];
  selectedAnswers: string[];
  setSelectedAnswers: React.Dispatch<React.SetStateAction<string[]>>;
}> = ({ results, selectedAnswers, setSelectedAnswers }) => {
  return (
    <Box>
      {results.map(({ text, percentage }) => (
        <Box
          key={text}
          onClick={() => {
            setSelectedAnswers((prev: string[]) => {
              if (prev.includes(text)) {
                return prev.filter((answer: string) => answer !== text);
              }
              return [...prev, text];
            });
          }}
          sx={{
            position: "relative",
            marginY: 1,
            padding: 1,
            borderRadius: 0.5,
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            zIndex: 1,
            color: "text.primary",
            height: 35,
            backgroundColor: selectedAnswers.includes(text) ? "background.active" : "transparent",
          }}
        >
          <Button
            type="button"
            data-analytics-id="polls-answer-select"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              backgroundColor: "transparent",
              padding: 0.5,
              zIndex: -1,
              display: "flex",
              justifyContent: "start",
            }}
          >
            <Box
              style={{
                width: `${percentage}%`,
              }}
              sx={({ palette }) => ({
                backgroundColor: palette.mode === "dark" ? "info.main" : "info.light",
                height: "100%",
                borderRadius: 0.5,
              })}
            ></Box>
          </Button>
          <Typography
            sx={{
              marginLeft: 1,
              maxWidth: "80%",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
            variant="body2"
          >
            {text}
          </Typography>
          <Typography
            sx={{
              marginLeft: 1,
            }}
            variant="body2"
            fontWeight={700}
          >
            {`${percentage}%`}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
